import React, { useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import '../assets/css/home.css';
const DayNight = () => {
    const [value, setValue] = useState(0);

    const images = [
        "/day_night_images/00.jpg",
        "/day_night_images/01.jpg",
        "/day_night_images/02.jpg",
        "/day_night_images/03.jpg",
        "/day_night_images/04.jpg",
        "/day_night_images/05.jpg",
        "/day_night_images/06.jpg",
        "/day_night_images/07.jpg",
        "/day_night_images/08.jpg",
        "/day_night_images/09.jpg",
        "/day_night_images/10.jpg",
        "/day_night_images/11.jpg",
        "/day_night_images/12.jpg",
        "/day_night_images/13.jpg",
        "/day_night_images/14.jpg",
        "/day_night_images/15.jpg",
        "/day_night_images/16.jpg",
        "/day_night_images/17.jpg",
        "/day_night_images/18.jpg",
        "/day_night_images/19.jpg",
        "/day_night_images/20.jpg",
        "/day_night_images/21.jpg",
        "/day_night_images/22.jpg",
        "/day_night_images/23.jpg",
        "/day_night_images/24.jpg",
        "/day_night_images/25.jpg",
        "/day_night_images/26.jpg",
        "/day_night_images/27.jpg",
        "/day_night_images/28.jpg",
        "/day_night_images/29.jpg",
        "/day_night_images/30.jpg",
        "/day_night_images/31.jpg",
        "/day_night_images/32.jpg",
        "/day_night_images/33.jpg",
        "/day_night_images/34.jpg",
        "/day_night_images/35.jpg",
        "/day_night_images/36.jpg",
        "/day_night_images/37.jpg",
        "/day_night_images/38.jpg",
        "/day_night_images/39.jpg",
        "/day_night_images/40.jpg",
        "/day_night_images/41.jpg",
        "/day_night_images/42.jpg",
        "/day_night_images/43.jpg",
        "/day_night_images/44.jpg",
        "/day_night_images/45.jpg",
        "/day_night_images/46.jpg",
        "/day_night_images/47.jpg",
        "/day_night_images/48.jpg",
        "/day_night_images/49.jpg",
        "/day_night_images/50.jpg",
        "/day_night_images/51.jpg",
        "/day_night_images/52.jpg",
        "/day_night_images/53.jpg",
        "/day_night_images/54.jpg",
        "/day_night_images/55.jpg",
        "/day_night_images/56.jpg",
        "/day_night_images/57.jpg",
        "/day_night_images/58.jpg",
        "/day_night_images/59.jpg",
        // "/day_night_images/60.jpg",
        // "/day_night_images/61.jpg",
        // "/day_night_images/62.jpg",
        // "/day_night_images/63.jpg",
        // "/day_night_images/64.jpg",
        // "/day_night_images/65.jpg",
        // "/day_night_images/66.jpg",
        // "/day_night_images/67.jpg",
        // "/day_night_images/68.jpg",
        // "/day_night_images/69.jpg",
        // "/day_night_images/70.jpg",
        // "/day_night_images/71.jpg",
        // "/day_night_images/72.jpg",
        // "/day_night_images/73.jpg",
        // "/day_night_images/74.jpg",
        // "/day_night_images/76.jpg",
        // "/day_night_images/76.jpg",
        // "/day_night_images/77.jpg",
        // "/day_night_images/78.jpg",
        // "/day_night_images/79.jpg",
        // "/day_night_images/80.jpg",
        // "/day_night_images/91.jpg",
        // "/day_night_images/92.jpg",
        // "/day_night_images/93.jpg",
        // "/day_night_images/94.jpg",
        // "/day_night_images/96.jpg",
        // "/day_night_images/96.jpg",
        // "/day_night_images/97.jpg",
        // "/day_night_images/98.jpg",
        // "/day_night_images/99.jpg",
        // "/day_night_images/100.jpg",
        // "/day_night_images/101.jpg",
        // "/day_night_images/102.jpg",
        // "/day_night_images/103.jpg",
        // "/day_night_images/104.jpg",
        // "/day_night_images/106.jpg",
        // "/day_night_images/106.jpg",
        // "/day_night_images/107.jpg",
        // "/day_night_images/108.jpg",
        // "/day_night_images/109.jpg",
        // "/day_night_images/100.jpg",
        // "/day_night_images/111.jpg",
        // "/day_night_images/112.jpg",
        // "/day_night_images/113.jpg",
        // "/day_night_images/114.jpg",
        // "/day_night_images/116.jpg",
        // "/day_night_images/116.jpg",
        // "/day_night_images/117.jpg",
        // "/day_night_images/118.jpg",
        // "/day_night_images/119.jpg",
    ];
    useEffect(() => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);
    return (
        <div className="full-container">
            <img src={`/day_night_images/${String(value).padStart(2, "0")}.jpg`} alt="" className="home_page_images" />
            <div className="home-slider-container">
                <Form.Range min={0} max={59} value={value}
                    onChange={(e) => setValue(e.target.value)} className="home_range_slider" />
                <div className="slider-labels">
                    <span className="label-left">Morning</span>
                    <span className="label-right">Evening</span>
                </div>
            </div>
        </div>
    )
}

export default DayNight;